import receiveCode from '@/postMessage/receiveCode'

export default (code) => {
  receiveCode({ code, loginType: 'wechat' })
}
